module.exports = __webpack_public_path__ + "static/img/about-bg.26bbbc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-bg.jpg
// module id = mW4G
// module chunks = 0